export {};

$(init);

const srcMap = {};

function init() {
    $('.tiles').each(eachTiles);
}

function eachTiles(tilesIndex, Tiles) {
    const $tilesRoot = $(Tiles);

    let $backgrounds;

    let [prevBackgroundIndex, nextBackgroundIndex] = [0, 1];

    let isBackgroundsCached = false;

    $tilesRoot.on(NLMK.TOUCHSTART_EVENT, '.tile', onTileMouseEnter);

    /**
     *
     * @param {MouseEvent} evt
     */
    function onTileMouseEnter(evt) {
        if (Modernizr.ios) {
            return true;
        }

        const $tile = $(evt.currentTarget);

        if (!isBackgroundsCached) {
            $tile
                .parent()
                .siblings()
                .children()
                .map((idx, Tile) => {
                    new Image().src = Tile.dataset.background;
                    if (Modernizr.webp) {
                        (async () => {
                            return await new Promise((resolve) => {
                                const image = new Image();
                                const src = Tile.dataset.background;
                                const webpSrc = src.replace(/\.(jpe?g|png)$/i, '.webp');

                                image.onerror = () => {
                                    resolve();

                                    srcMap[src] = src;
                                };

                                image.onload = () => {
                                    srcMap[src] = webpSrc;

                                    resolve();
                                };

                                image.src = webpSrc;
                            });
                        })();
                    }
                });

            isBackgroundsCached = true;
        }

        const background = $tile.data('background');

        if (!$backgrounds) {
            $backgrounds = $tilesRoot.find('.tiles__background');
        }

        [prevBackgroundIndex, nextBackgroundIndex] = [nextBackgroundIndex, prevBackgroundIndex];

        $backgrounds
            .css('background-image', `url(${srcMap[background] || background})`)
            .eq(nextBackgroundIndex)
            .addClass('active');

        $backgrounds.eq(prevBackgroundIndex).removeClass('active');
    }
}



// WEBPACK FOOTER //
// ./js/main/module/tiles.js